import { useQuery } from "@tanstack/react-query";
import { getWeather, type WeatherPlace } from "@services/zenith/weather";

/** The weather at a place, refreshed every 10 minutes while the page is visible; idle without a place. */
export const useGetWeather = (params?: WeatherPlace & { lang: string }) => {
  return useQuery({
    queryKey: ["weather", params],
    queryFn: () => getWeather(params!),
    enabled: Boolean(params),
    refetchInterval: 10 * 60_000,
    // Another place's report must never show under a newly chosen place's name.
    keepPreviousData: false,
    // The API already falls back on its last good report; a retry would only hit OpenWeather again.
    retry: false,
    // The card says weather is unavailable; an outage must not take the dashboard down with it.
    useErrorBoundary: false,
  });
};
